module.exports = __webpack_public_path__ + "img/linke-logo.49ac4e64.svg";